<template>
  <img
    src="/logo-small.svg"
    style="width: 1em; height: 1em;"
  >
</template>
